(() => {
  if (window.NovyMedia) return;
  const assetBase = document.currentScript.src;
  const registered = new WeakSet();
  const visible = new Set();
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const saveData = Boolean(navigator.connection && navigator.connection.saveData);

  function load(element) {
    if (!element || element.dataset.novyLoaded === 'true') return;
    const source = element.dataset.novySrc;
    if (element.dataset.novyPoster) element.poster = element.dataset.novyPoster;
    if (source) element.src = source;
    element.querySelectorAll('source[data-novy-src]').forEach(node => {
      node.src = node.dataset.novySrc;
    });
    element.dataset.novyLoaded = 'true';
    if (element.tagName === 'VIDEO') element.load();
  }

  function play(element, options = {}) {
    if (!element) return;
    load(element);
    if (element.tagName !== 'VIDEO') return;
    if (typeof options.muted === 'boolean') element.muted = options.muted;
    const result = element.play();
    if (result && result.catch) result.catch(() => {});
  }

  function activate(element) {
    if (document.hidden) return;
    const autoplay = element.hasAttribute('data-novy-autoplay');
    if (autoplay && (reduceMotion.matches || saveData)) {
      if (element.tagName === 'VIDEO') element.controls = true;
      return;
    }
    load(element);
    if (autoplay) play(element, { muted: true });
  }

  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting && entry.intersectionRatio >= 0.1) {
        visible.add(entry.target);
        activate(entry.target);
      } else {
        visible.delete(entry.target);
        if (entry.target.tagName === 'VIDEO') entry.target.pause();
      }
    });
  }, { threshold: [0, 0.1], rootMargin: '0px' }) : null;

  function init(root = document) {
    root.querySelectorAll('[data-novy-media]').forEach(element => {
      if (registered.has(element)) return;
      registered.add(element);
      if (element.dataset.novyPosterAsset) element.poster = new URL(element.dataset.novyPosterAsset, assetBase).href;
      if (element.tagName === 'VIDEO') {
        element.addEventListener('pointerdown', () => load(element), { once: true });
        element.addEventListener('keydown', () => load(element), { once: true });
      }
      if (element.hasAttribute('data-novy-manual')) return;
      if (observer) observer.observe(element);
      else if (element.tagName === 'VIDEO') element.controls = true;
    });
  }

  document.addEventListener('visibilitychange', () => {
    visible.forEach(element => {
      if (document.hidden && element.tagName === 'VIDEO') element.pause();
      else activate(element);
    });
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-novy-media]').forEach(element => {
      if (observer) observer.unobserve(element);
      visible.delete(element);
      if (element.tagName === 'VIDEO') element.pause();
    });
  });
  window.NovyMedia = { init, load, play };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
})();
